import axios from "axios";

export const addCartDataAfterLogin = () => {
  const cartdata = localStorage.getItem("cart");
  const cartdataParse = JSON.parse(cartdata);
  const data = localStorage.getItem("auth");
  const parseData = JSON.parse(data);
  const symbol = getPriceSymbole();
  const exchangeRate = getExchangeRate();

  const addCarttoDatabase = async (dataArr, user_id) => {
    if (user_id !== "") {
      let cart_data = {
        id: dataArr.product_id,
        product_id: dataArr.product_id,
        color: dataArr.color,
        choice_2: dataArr.variations.Size,
        quantity: dataArr.quantity,
        customer_id: user_id,
        price_data: { currency: symbol, exchange_rate: exchangeRate },
      };
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/cart/add`,
          cart_data
        );
      } catch (error) {
        console.log(error);
      }
    }
  };

  if (parseData && parseData !== null) {
    let user_id = parseData.user.id;
    if (cartdataParse && cartdataParse !== null) {
      cartdataParse?.forEach((dataArr) => {
        addCarttoDatabase(dataArr, user_id);
      });
    }
  }
  return true;
};

export const getOnlyPhoneNo = (c_code, phone_number) => {
  return phone_number.replace(c_code, "");
};

export const currencyFormat = (currency, price) => {
  if (price > 0) {
    // return currency + "" + Math.round(num * 100) / 100;
    return currency + " " + price;
  } else {
    return currency + " " + price;
  }
};

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const objectInRowByKey = (dataObject, value) => {
  //return 0;
  // console.log(value, dataObject)
  for (let j = 0; j <= dataObject.length; j++) {
    if (value === dataObject[j]["type"]) {
      if (dataObject[j]["qty"] > 0) {
        return 0;
      } else {
        return 1;
      }
    }
  }
  return 0;
};

export const getPrice = (price, format = true) => {
  let country_currency = sessionStorage.getItem("country_currency");
  const parseData = JSON.parse(country_currency);
  var amount = 0;
  let countryCode = parseData?.code;
  if (parseData?.status && parseData?.exchange_rate > 0) {
    let finalExchange = 0;
    if (countryCode !== "INR") {
      //finalExchange = (parseData.exchange_rate*0.25)+parseData.exchange_rate;
      finalExchange = parseData?.exchange_rate * 0.15 + parseData?.exchange_rate;
    } else {
      finalExchange = parseData?.exchange_rate;
    }

    let price_main = price * finalExchange;
    //amount= Math.round((price_main * 100) / 100);
    //
    if (countryCode !== "INR") {
      amount = parseFloat(price_main?.toFixed(2));
    } else {
      amount = Math.round(price_main);
    }
  } else {
    //return Math.round(price).toLocaleString('en-IN');
    //amount= Math.round(price);
    if (countryCode !== "INR") {
      amount = parseFloat(price?.toFixed(2));
    } else {
      amount = Math.round(price);
    }
  }

  if (format) {
    return formatPrice(amount);
  } else {
    return amount;
  }
};

export const getFinalPricewithSymbol = (discount, discount_type, price) => {
  var amount = 0;
  if (discount) {
    amount =
      discount_type === "percent"
        ? (price * (100 - discount)) / 100
        : price - discount;
  } else {
    amount = price;
  }
  amount = discount
    ? discount_type === "percent"
      ? (price * (100 - discount)) / 100
      : price - discount
    : price;

  return amount;
};

export const getRoundPrice = (price) => {
  let round_price = Math.ceil(price);
  return round_price;
};

export const getPriceForOrder = (price, exchangeRate) => {
  let price_main = price * exchangeRate;
  /* return Math.round(price_main);  */
  return parseFloat(price_main?.toFixed(2));
};

export const formatPrice = (price) => {
  let country_data = sessionStorage.getItem("country_data");
  const parseData = JSON.parse(country_data);
  /*  return Math.round(price).toLocaleString(parseData.languages); */
  return parseFloat(price?.toFixed(2)).toLocaleString(parseData?.languages);
};

export const getPriceSymbole = (price) => {
  let country_currency = sessionStorage.getItem("country_currency");
  const parseData = JSON.parse(country_currency);
  if (parseData?.status && parseData.symbol !== "") {
    return parseData.symbol;
  } else {
    return "₹";
  }
};

export const getPriceCurrencyCode = () => {
  let country_currency = sessionStorage.getItem("country_currency");
  const parseData = JSON.parse(country_currency);
  if (parseData?.status && parseData.code !== "") {
    return parseData.code;
  } else {
    return "INR";
  }
};

export const getExchangeRate = () => {
  let country_currency = sessionStorage.getItem("country_currency");
  const parseData = JSON.parse(country_currency);
  if (parseData?.status && parseData.exchange_rate > 0) {
    let countryCode = parseData?.code;
    let finalExchange = 0;
    if (countryCode !== "INR") {
      finalExchange = parseData.exchange_rate * 0.15 + parseData.exchange_rate;
      //finalExchange = (parseData.exchange_rate*0.25)+parseData.exchange_rate;
    } else {
      finalExchange = parseData.exchange_rate;
    }
    return finalExchange;
  } else {
    return 1;
  }
};

export const getLocalCountryData = () => {
  const data = sessionStorage.getItem("country_data");
  const parseData = JSON.parse(data);
  return parseData;
};

export const dateInMDY = (date) => {
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  var d = new Date(date),
    //monthNum = '' + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  let month_name = month[d.getMonth()];

  if (day.length < 2) day = "0" + day;
  return [month_name + " " + day, year].join(", ");
};

export const getCurrentCountry = async () => {
  await fetch("https://ipapi.co/json/")
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((recentUsers) => {
      // Process the list of recent users
      console.log("Recent Users:", recentUsers);
    })
    .catch((error) => console.error("Error:", error));
};

export const OrderStatusFormat = (order_status) => {
  var classes = "badge badge-info";
  if (order_status === "confirmed" || order_status === "returned") {
    classes = "badge badge-success";
  } else if (order_status === "failed" || order_status === "canceled") {
    classes = "badge badge-danger";
  }
  let replacedStr = order_status.replace(/_/g, " ");

  return '<span className="' + classes + '">' + replacedStr + "</span>";
};

export const messageClass = (type) => {
  var mClass = "";
  if (type === "open") {
    mClass = "badge badge-success";
  } else if (type === "close") {
    mClass = "badge badge-danger";
  } else {
    mClass = "badge badge-info";
  }
  return mClass;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const calculatePercentage = (amount, discountRanges) => {
  const range = discountRanges.find(
    (range) => amount >= range.start_amount && amount <= range.end_amount
  );
  if (!range) return { deducted: 0, remaining: 1 };
  const deducted = range.discount / 100;
  const remaining = 1 - deducted;
  return { deducted, remaining };
};
export const formatUIText = (text) => {
  return text
    .replace(/_/g, " ") // replace _ with space
    .replace(/razor ?pay/gi, "Razor Pay") // standardize Razor Pay
    .replace(/^([a-z])/, (m) => m.toUpperCase()); // capitalize first letter
};

export const shippingTotal = (shipping) => {
  const surfaceShippingTotal = shipping
    .filter((item) => item.mode_of_transport === "Surface")
    .reduce((total, item) => total + item.shipping_charge, 0);
  return surfaceShippingTotal;
};

export const expressShippingTotal = (shipping) => {
  const expressShippingTotal = shipping
    .filter((item) => item.mode_of_transport === "Air")
    .reduce((total, item) => total + item.shipping_charge, 0);
  return expressShippingTotal;
};

export const getFormattedFutureDate = (daysToAdd) => {
  const date = new Date();
  date.setDate(date.getDate() + daysToAdd);

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const dayName = days[date.getDay()];
  const day = date.getDate();
  const month = date.getMonth() + 1; // months are 0-indexed

  return `${dayName}, ${day}/${month}`;
};
let tabOpened = false;

export const reportConversion = (url) => {
  const callback = () => {
    if (url && !tabOpened) {
      tabOpened = true;
      window.open(url, "_blank");
      setTimeout(() => { tabOpened = false; }, 1000); // reset after 1s
    }
  };

  if (typeof window.gtag !== "undefined") {
    window.gtag("event", "conversion", {
      send_to: "AW-11502183481/tMRUCOmy0pgbELnI1ewq",
      event_callback: callback,
    });
  } else {
    callback();
  }
};
